import {useQueries} from 'react-query'
import {deleteTrip, fetchTripList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import TripForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import DeleteButton from '../../../components/DeleteButton'
import ModalWithForm from '../../../components/ModalWithForm'
import EditBtn from '../../../components/EditBtn'
import {Button, Dropdown} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {formatTime} from '../../../helpers/dateFunctions'
import {Helmet} from 'react-helmet'
import WithModal from '../../../components/WithModal'
import ViewAll from '../../../components/ViewAll'
import StudentsInTrip from './StudenstInTrip'
import TripUpload from '../trip-upload/Index'
import {KTIcon} from '../../../_metronic/helpers'
import {format} from 'date-fns'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import {useState} from 'react'
import PortalDropdown from '../../../components/PortalDropdown'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import MoreInfoLabel from '../../../components/MoreInfoLabel'
import EditLabel from '../../../components/EditLabel'
import DeleteLabel from '../../../components/DeleteLabel'
import {fetchRootList} from '../roots/api'
import {fetchShiftList} from '../shift/api'
import {fetchDriverList} from '../driver/api'
import TopBarProgress from 'react-topbar-progress-indicator'
import {fetchConductorList} from '../conductor/api'
import TableFilterDropdown from '../../../components/tableFilterDropdown/TableFilterDropdown'
import {fetchTripNumberList} from '../tripNumber/api'
import {fetchBusList} from '../bus/api'

const tripBreadcrumbs = [
  {
    title: 'School Management',
    path: 'school-management/stay',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function Stay() {
  const [filters, setFilters] = useState({})
  const results = useQueries([
    {
      queryKey: ['stayList', filters],
      queryFn: () => fetchTripList({filters}),

      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
    {
      queryKey: 'routesList',
      queryFn: fetchRootList,

      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'classList',
      queryFn: fetchShiftList,

      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'driverList',
      queryFn: fetchDriverList,

      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'conductors',
      queryFn: fetchConductorList,

      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'tripNumberList',
      queryFn: fetchTripNumberList,

      refetchOnWindowFocus: false,
    },
    {
      queryKey: 'busList',
      queryFn: fetchBusList,

      refetchOnWindowFocus: false,
    },
  ])

  const tripResponse = results[0]
  const rootResponse = results[1]
  const shiftResponse = results[2]
  const driverResponse = results[3]
  const conductorResponse = results[4]
  const tripNumberResponse = results[5]
  const busResponse = results[6]

  if (
    busResponse.isLoading ||
    tripResponse.isLoading ||
    rootResponse.isLoading ||
    shiftResponse.isLoading ||
    driverResponse.isLoading
  ) {
    return <Processing />
  }

  const filterFields = [
    {
      name: 'trip_status',
      label: 'Status',
      options: [
        {label: 'Active', value: '1'},
        {label: 'Inactive', value: '0'},
      ],
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      name: 'trip_type',
      label: 'Trip Type',
      options: [
        {label: 'Pick Up', value: 'pickup'},
        {label: 'Drop', value: 'drop'},
      ],
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      name: 'route_id',
      label: 'Route',
      options: rootResponse.data.data,
      optionLabel: 'route_name',
      optionValue: 'route_id',
    },
    {
      name: 'shift_id',
      label: 'Shift',
      options: shiftResponse.data.data,
      optionLabel: 'shift_name',
      optionValue: 'shift_id',
    },
    {
      name: 'driver_id',
      label: 'Driver',
      options: driverResponse.data.data,
      optionLabel: 'driver_name',
      optionValue: 'driver_id',
    },
    {
      name: 'conductor_id',
      label: 'Bus Attendee',
      options: conductorResponse.data.data,
      optionLabel: 'conductor_name',
      optionValue: 'conductor_id',
    },
    {
      name: 'trip_number',
      label: 'Trip Number',
      options: tripNumberResponse.data.data,
      optionLabel: 'trip_number',
      optionValue: 'trip_number',
    },
    {
      name: 'bus_name',
      label: 'Bus',
      options: busResponse.data.data,
      optionLabel: 'bus_name',
      optionValue: 'bus_id',
      selectProps: {
        getOptionLabel: (option) => option.bus_name + ' - ' + option.bus_registration_number,
      },
    },
  ]

  const handleApplyFilters = (filters) => {
    setFilters(filters)
    console.log('Applied filters:', filters)
  }

  const cellModifier = {
    trip_status: ({value}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },

    bus_name: ({row}) => {
      return `${row.original.bus_name} - ${row.original.bus_number}`
    },

    trip_type: ({row}) => {
      const tripType = row.original.trip_type

      return (
        <div className="d-flex align-items-center gap-2">
          <span className={`badge bg-light border border-secondary text-uppercase`}>
            {tripType}
          </span>
          <span className=" small">
            {formatTime(row.original.start_time)} &ndash; {formatTime(row.original.end_time)}
          </span>
        </div>
      )
    },
    more: ({row}) => {
      const orderedFields = [
        ...Object.entries(viewProps.Trip.primaryFieldsToLabelMap),
        ...Object.entries(viewProps.Trip.secondaryFieldsToMap),
      ]
      return (
        <WithModal
          renderModalBody={() => (
            <ViewAll data={row.original} cellModifier={cellModifier} fieldOrder={orderedFields} />
          )}
          modalTitle={
            <span>
              Details of <span className="text-primary">{row.original.trip_name}</span>
            </span>
          }
          modalAttrs={{backdrop: true, size: 'lg'}}
        >
          <MoreInfoLabel />
        </WithModal>
      )
    },
    Actions: ({row}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <WithModal
              renderModalBody={() => <StudentsInTrip tripId={row.original.trip_id} />}
              modalTitle={
                <span>
                  Students in trip <span className="text-primary">{row.original.trip_name}</span>
                </span>
              }
              modalAttrs={{size: 'xl'}}
              triggerClassName="d-block"
            >
              <div className="px-3 py-2 d-flex align-items-center">
                <KTIcon iconName="user" className="fs-6" />
                <span className="ms-2">Students in Trip</span>
              </div>
            </WithModal>
          </span>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Trip'}
              triggerClassName="d-block"
              initialValues={row.original}
              onSubmit={tripResponse.refetch}
              Form={TripForm}
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteTrip(row.original.trip_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await tripResponse.refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }
  return (
    <>
      <Helmet>
        <title>TrackNAB | Trips</title>
      </Helmet>
      <PageTitle breadcrumbs={tripBreadcrumbs}>Trip</PageTitle>
      {tripResponse.isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={tripResponse.data.data}
          {...viewProps.Trip}
          fieldToLabelMap={viewProps.Trip.primaryFieldsToLabelMap}
          Form={TripForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['More Info', 'Actions']}
          headerExtras={
            <>
              <TableFilterDropdown
                fields={filterFields}
                onApply={handleApplyFilters}
                onReset={() => setFilters({})}
                buttonClassName="ms-4"
                menuStyles={{width: '400px'}}
                colProps={{sm: 6}}
              />
              <ModalWithForm
                modalTitle={'Add Trip'}
                triggerClassName="ms-auto"
                onSubmit={tripResponse.refetch}
                Form={TripForm}
              >
                <Button size="sm">Add Trip</Button>
              </ModalWithForm>
              <ModalWithForm
                modalTitle={'Trip Upload'}
                onSubmit={tripResponse.refetch}
                Form={TripUpload}
                modalAttrs={{size: 'lg'}}
              >
                <Button
                  variant="light"
                  size="sm"
                  className="ms-3 d-flex align-items-center gap-2 ps-4 pe-3 text-primary border border-primary rounded-3"
                >
                  <span>Upload</span>
                  <KTIcon iconName="file-up" className="fs-3 text-primary" />
                </Button>
              </ModalWithForm>
            </>
          }
        />
      )}
      {tripResponse.isRefetching && <TopBarProgress />}
      <Toaster />
    </>
  )
}

export default Stay
